/* eslint-disable strict,prefer-template,no-var,object-shorthand */

const EnvironmentNames = {
    DOCKER_STAGE: "docker-stage",
    DOCKER_CLUSTER: "docker-cluster",
    BRANCH: "branch",
    DEV: "dev",
    LOCAL: "local",
    PROD: "prod",
    CNC: "cnc"
};

const PROD_CNC_VIEW_FULL_BASE_URL = "https://cnc-api.zmags.com/view/full/";
const PROD_CNC_VIEW_LITE_BASE_URL = "https://cnc-api.zmags.com/view/lite/";
const DEV_CNC_VIEW_FULL_BASE_URL = "http://nocache-cnc-api-dev.zmags.com/view/full/";
const DEV_CNC_VIEW_LITE_BASE_URL = "http://nocache-cnc-api-dev.zmags.com/view/lite/";
const DOCKER_STAGE_CNC_VIEW_FULL_BASE_URL = "http://localhost:8081/view/full/";
const DOCKER_STAGE_CNC_VIEW_LITE_BASE_URL = "http://localhost:8081/view/lite/";

const PROD_PSD_IMPORT_BASE_URL = "https://design-file-import.creator-prod.zmags.com";
const DEV_PSD_IMPORT_BASE_URL = "https://design-file-import.creator-stage.zmags.com";

const PROD_BEHAVIOR_UI_BASE_URL = "https://behaviors.zmags.com";
const DEV_BEHAVIOR_UI_BASE_URL = "https://staging.behaviors.zmags.com";

const PROD_CREATOR_SETTINGS_API_BASE_URL = "https://creator-settings.api.zmags.com";
const DEV_CREATOR_SETTINGS_API_BASE_URL = "https://creator-settings-stg.api.zmags.com";

const PROD_C3_API_BASE_URI="https://contentcontrol.api.zmags.com";
const STAGE_C3_API_BASE_URI="https://c3-api-stg.sandbox-dev.zmags.com";
const DEV_C3_API_BASE_URI="https://c3-api-dev.sandbox-dev.zmags.com";

const PROD_LIVE_API_BASE_URL = "https://creator-api.zmags.com";
const PROD_EDITOR_BASE_URL = "//creator.zmags.com";
const PROD_VIEWER_BASE_URL = "//c.zmags.com";
const PROD_VIEWER_ALIAS_BASE_URL = "//creator.zmags.com";

const DEV_LIVE_API_BASE_URL = "https://creator-dev-api.zmags.com";
const DEV_EDITOR_BASE_URL = "//creator-dev.zmags.com";

const DEV_VIEWER_BASE_URL = "//c-dev.zmags.com";
const DEV_CNC_SSR_API_BASE_URL = "//c-dev.zmags.com";
const DEV_VIEWER_ALIAS_BASE_URL = "//creator-dev.zmags.com";

const DEV_ERROR_QUEUE_URL = "https://c-dev.zmags.com/queue/error/";
const PROD_ERROR_QUEUE_URL = "https://c.zmags.com/queue/error/";

const DEV_CAS_URL = "https://cas-stage.zma.gs/";
const PROD_CAS_URL = "https://cas.zma.gs/";

const STATSD_URL = "https://statsd.zmags.com/stats";

const AUTH0_DOMAIN = "https://zmags.us.auth0.com";
const AUTH0_AUDIENCE = "https://api.zmags.com/";
const PROD_AUTH0_CLIENT_ID = "XGTeepJiX2c78VRgP8OFxN0Mf4kggvby";
const DEV_AUTH0_CLIENT_ID = "nLsZ7qxH6nRW5AuHXvDC7PeBeK67B7b5";

const LOCAL_LIVE_API_BASE_URL = "http://localhost:8080/experience-server";
const LOCAL_EDITOR_BASE_URL = "http://localhost:9009/mosaik"; // Local S3
const PROD_EDITOR_SEGMENT_IO_KEY = "20jbiv8frx";
const LOCAL_EDITOR_SEGMENT_IO_KEY = "tewkjvnii8";

const DOCKER_LIVE_API_BASE_URL = "http://localhost:8080/experience-server";
const DOCKER_EDITOR_BASE_URL = "http://localhost:9000/mosaik"; // Local S3

const DOCKER_STAGE_LIVE_API_BASE_URL = "http://localhost:8080/experience-server";
const DOCKER_STAGE_EDITOR_BASE_URL = "http://localhost:9000";

const BRANCH_EDITOR_SEGMENT_IO_KEY = "XEgfW02w90ZP4BgQWnZ6XeZYjUJZEOeR";

const COMMUNITY_BASE_URL = "https://creatorcommunity.zmags.com";
const SALES_EMAIL = "sales@zmags.com";
const SUPPORT_EMAIL = "support@zmags.com";
const CLOUDINARY_PROVIDER_BASE_URL = "//images.creator-stage.zmags.com/image/upload";
const CLOUDINARY_PROVIDER_PRODUCTION_URL = "https://images.creator-prod.zmags.com/image/upload";
const OMETRIA_API_STAGE_URL = "https://tst-ometria.api.zmags.com/v1/email/generate";
const OMETRIA_API_PRODUCTION_URL = "https://ometria.api.zmags.com/v1/email/generate";
const KLAVIYO_API_STAGE_URL= "https://tst-klaviyo.api.zmags.com/v1/email/generate";
const KLAVIYO_API_PRODUCTION_URL="https://klaviyo.api.zmags.com/v1/email/generate";
const SFMC_API_STAGE_URL= "https://tst-sfmc.api.zmags.com/v1/email/generate";
const SFMC_API_PRODUCTION_URL="https://sfmc.api.zmags.com/v1/email/generate";
const GOOGLE_WEBFONTS_API_BASE_URL = "https://www.googleapis.com/webfonts/v1/webfonts";
const GOOGLE_WEBFONTS_API_KEY  = "AIzaSyBxV3A9pK4DwgaCBN3bXlU6HTTe86cz5WI";

const BRANCH_IMAGES_BASE_URL  = "https://s3-eu-west-1.amazonaws.com/zmags.mosaik.branch";

const SENTRY_DSN = "https://a57bc1d597814a1f91c36f3b74cce2ed@o224008.ingest.sentry.io/5320460";

const PROD_CONTENT_CONTROL_URL = "https://manage.creatorbyzmags.com/";
const DEV_CONTENT_CONTROL_URL = "https://staging.manage.creatorbyzmags.com/";
const LOCAL_CONTENT_CONTROL_URL = "https://development.manage.creatorbyzmags.com/";

// Docker Cluster
const dockerCluster = process.env.DOCKER_CLUSTER_VAR;

const DOCKER_CLUSTER_PSD_IMPORT_BASE_URL = "http://" + dockerCluster + ".design-file-import.branch.creator-dev-act.zmags.com";
const DOCKER_CLUSTER_BEHAVIOR_UI_BASE_URL = "https://staging.behaviors.zmags.com/";
const DOCKER_CLUSTER_CREATOR_BASE_URL = "http://creator." + dockerCluster + ".branch.creator-dev-act.zmags.com";
const DOCKER_CLUSTER_CNC_BASE_URL = "http://" + dockerCluster + ".cnc-api.branch.creator-dev-act.zmags.com";
const DOCKER_CLUSTER_ERROR_QUEUE_URL = DOCKER_CLUSTER_CREATOR_BASE_URL + "/queue/error/";
const DOCKER_CLUSTER_LIVE_API_BASE_URL = "http://" + dockerCluster + ".creator-api.branch.creator-dev-act.zmags.com/experience-server";
// These non-branch-specific URLs direct through Akamai, which redirects to the appropriate cluster based on headers.
const CLOUDINARY_PROVIDER_DOCKER_CLUSTER_URL = "http://images.branch.creator-dev-act.zmags.com/image/upload";

const MATOMO_LOCAL_CONFIG = {
    trackingScriptUrl: "//c-dev.z-analytics.net/reporting/optimize/ztracker.js", // TODO: for heatmaps does it have to be per client?
    trackerUrl: "//localhost:8004/clients/perfumania/matomo/piwik.php", // this gets overridden by zelp
    dashboardUrl: "http://localhost:8001/modules/Auth/Auth.php",
    segmentUrl: "http://localhost:8001/modules/Onboarding/SegmentCreation.php",
    siteID: 1
};

const MATOMO_DOCKER_CLUSTER_CONFIG = {
    trackingScriptUrl: "//creator.branch.creator-dev-act.zmags.com/reporting/optimize/ztracker.js",
    trackerUrl: "",  // gets overriden by zelp
    dashboardUrl: "//auth.reporting.creator-stage.zmags.com", // TODO: needs staging url auth.reporting.creator-stage.zmags.com?
    segmentUrl: "//onboarding.reporting.creator-stage.zmags.com/SegmentCreation.php",
    siteID: 1
};

const MATOMO_DOCKER_CONFIG = {
    trackingScriptUrl: "//c-dev.z-analytics.net/reporting/optimize/ztracker.js", // TODO: for heatmaps does it have to be per client?
    trackerUrl: "//localhost:8004/clients/perfumania/matomo/piwik.php", // this gets overridden by zelp
    dashboardUrl: "http://localhost:8001/modules/Auth/Auth.php",
    segmentUrl: "http://localhost:8001/modules/Onboarding/SegmentCreation.php",
    siteID: 1
};

const MATOMO_BRANCH_CONFIG = {
    trackingScriptUrl: "//c-dev.z-analytics.net/reporting/optimize/ztracker.js",
    trackerUrl: "", // gets overriden by zelp
    dashboardUrl: "http://localhost:8001/modules/Auth/Auth.php",
    segmentUrl: "http://localhost:8001/modules/Onboarding/SegmentCreation.php",
    siteID: 1
};

const MATOMO_DEV_CONFIG = {
    trackingScriptUrl: "//c-dev.z-analytics.net/reporting/optimize/ztracker.js",
    trackerUrl: "",  // gets overriden by zelp
    dashboardUrl: "//auth.reporting.creator-stage.zmags.com", // TODO: needs staging url auth.reporting.creator-stage.zmags.com?
    segmentUrl: "//onboarding.reporting.creator-stage.zmags.com/SegmentCreation.php",
    siteID: 1
};

const MATOMO_PROD_CONFIG = {
    trackingScriptUrl: "//c.z-analytics.net/reporting/optimize/ztracker.js",
    trackerUrl: "", // gets overriden by zelp
    dashboardUrl: "//auth.reporting.creator-prod.zmags.com", // TODO: needs a prod url
    segmentUrl: "//onboarding.reporting.creator-prod.zmags.com/SegmentCreation.php",
    siteID: 1
};

const CNC_STATIC_ASSETS = [
    "client.js",
    "manifest.js",
    "vendor.js",
    "styles.css"
]

const ZSITES_LOCAL_URL = "http://localhost:8001/modules/Auth/Auth.php";
const ZSITES_DOCKER_URL = "http://localhost:8001/modules/Auth/Auth.php";
const ZSITES_BRANCH_URL = "http://localhost:8001/modules/Auth/Auth.php";
const ZSITES_DEV_URL = "//auth.reporting.creator-stage.zmags.com/"; // TODO: needs staging url auth.reporting.creator-stage.zmags.com?
const ZSITES_PROD_URL = "//auth.reporting.creator-prod.zmags.com/"; // TODO: needs a prod url
const ZSITES_SECRET = "zM4gzS3cr3t";
//const ZSITES_DOCKER_CLUSTER_URL = "//auth." + dockerCluster + ".branch.creator-dev-act.pvt.zmags.com/";

// NOTE: This is the proxy port number, that proxies over to inventory  (inventory's port is actually 9903)
const INVENTORY_LOCAL_BASE_URL = "http://localhost:9904";
const INVENTORY_DOCKER_BASE_URL = "http://localhost:9904";
const INVENTORY_STAGE_BASE_URL = "https://authproxy.creator-stage.zmags.com";
const INVENTORY_PROD_BASE_URL = "https://authproxy.creator-prod.zmags.com";
const INVENTORY_DOCKER_CLUSTER_BASE_URL = "http://authproxy." + dockerCluster + ".branch.creator-dev-act.zmags.com:9904";

const INVENTORY_PRODUCT_URL = "/inventory/v1/products/map";

// TODO: Create a way to run inventory answerfiles locally?
const ANSWERFILE_STAGE_BASE_URL = "https://static.inventory.creator-stage.zmags.com";
const ANSWERFILE_PROD_BASE_URL = "https://static.inventory.creator-prod.zmags.com";
const ANSWERFILE_DOCKER_CLUSTER_BASE_URL = "http://zmags.dev.branch." + dockerCluster + ".web.inventory.s3-website-us-east-1.amazonaws.com";

const ANSWERFILE_DYNAMIC_PRICING_URL = "/dynamic_pricing/answer_files/";

// MS-PROXY
const MS_PROXY_STAGE_BASE_URL = "https://authproxy.creator-stage.zmags.com";
const MS_PROXY_PROD_BASE_URL = "https://authproxy.creator-prod.zmags.com";
const MS_PROXY_LOCAL_BASE_URL = "http://localhost:9904";
const MS_PROXY_DOCKER_STAGE_BASE_URL = MS_PROXY_STAGE_BASE_URL; //docker talks to stage was the original value!  Not sure this was correct @eric?
const MS_PROXY_DOCKER_BASE_URL = MS_PROXY_STAGE_BASE_URL; //docker talks to stage was the original value!  Not sure this was correct @eric?
const MS_PROXY_BRANCH_BASE_URL = MS_PROXY_STAGE_BASE_URL; //not sure this is correct.  Old code defined to go here but experiences talks to stage in this context! @Eric (definition was in the const BRANCH_CONFIG setting)
const MS_PROXY_DOCKER_CLUSTER_BASE_URL = "http://authproxy." + dockerCluster + ".branch.creator-dev-act.zmags.com:9904"

// MS-EXPERIENCES
const MS_EXPERIENCES_LOCAL_BASE_URL = "http://localhost:9905"; //DIRECT to ms_experiences
const MS_EXPERIENCES_DOCKER_BASE_URL = "http://localhost:9905"; //DIRECT to ms_experiences
const MS_EXPERIENCES_BRANCH_BASE_URL = "http://internal.experiences.creator-stage.zmags.com:9905"; //DIRECT to ms_experiences
const MS_EXPERIENCES_STAGE_BASE_URL = MS_PROXY_STAGE_BASE_URL; //route through ms_proxy
const MS_EXPERIENCES_PROD_BASE_URL = MS_PROXY_PROD_BASE_URL; //route through ms_proxy
const MS_EXPERIENCES_DOCKER_CLUSTER_BASE_URL = MS_PROXY_DOCKER_CLUSTER_BASE_URL;

// PATH TO URL2PNG for experiences
const MS_PROXY_EXPERIENCES = "/experiences"; //additional path needed for routed calls through ms-proxy to reach it's defined ms-experiences endpoint.
const MS_PROXY_COMPANY = "/company/";
const MS_EXPERIENCES_URL2PNG_URL = "/v1/experience/signed/url2png/";
const MS_EXPERIENCES_SHARED_ENTITY_URL = "/v1/sharedEntity/";


/**
 * Production config
 *
 * adminApiBaseUrl:                 String      The API url where editor talks to(editor backend),
 * editorBaseUrl:                   String      The url where we open the editor page,
 * viewerBaseUrl:                   String      The url where we open the viewer page,
 * viewerApiBaseUrl:                String      The url where viewer requests assets and all other data(experiences, config etc),
 * viewerAliasApiBaseUrl:           String      The alias url of assets for parallel images downloading,
 * communityBaseUrl:                String      The url where we open the community page
 * salesEmail:                      String      The email address of sales team
 * supportEmail:                    String      The email address of customer support
 * editorSegmentIOKey:              String      The segmentIO key for editor
 * matomoConfig:                    Object      The configuration of the Matomo tracking used by the viewer.
 * errorQueueUrl:                   String      The url used to dump all front end errors from both editor and viewer
 * enableLogging:                   Number      The default logging level {@see util/Logger.js class}
 * logId:                           String      Optional postfix for all logger names when more than one channel injects a viewer on the same page {@see util/Logger.js class}
 * trackErrors:                     Boolean     Enable/disable error tracking. Errors will be reported to StatsD
 * sentryEnabled:                   Boolean     Enable/disable error tracking with Sentry.
 * sentryDSN:                       String      Data Source Name for Sentry.io analytics to be delivered to.
 * experienceId:                    String      The value of current experience id, used in the viewer
 * groupId:                         String      The value of current group id, used in the viewer
 * scene:                           Number      The initial scene to show, used in the viewer
 * statsDBucket:                    String      the statistics bucket name
 * version:                         String      The build version
 */
const PROD_CONFIG = {
    env: "PROD",
    cncViewFullBaseUrl: PROD_CNC_VIEW_FULL_BASE_URL,
    cncViewLiteBaseUrl: PROD_CNC_VIEW_LITE_BASE_URL,
    psdImportBaseUrl: PROD_PSD_IMPORT_BASE_URL,
    behaviorUiBaseUrl: PROD_BEHAVIOR_UI_BASE_URL,
    creatorSettingApiBaseUrl: PROD_CREATOR_SETTINGS_API_BASE_URL,
    c3ApibaseUrl: PROD_C3_API_BASE_URI,
    adminApiBaseUrl: PROD_LIVE_API_BASE_URL,
    editorBaseUrl: PROD_EDITOR_BASE_URL,
    viewerBaseUrl: PROD_VIEWER_BASE_URL,
    viewerApiBaseUrl: PROD_VIEWER_BASE_URL,
    cncStaticAssetsBaseUrl: PROD_VIEWER_BASE_URL + "/static/",
    cncStaticAssetsFiles: CNC_STATIC_ASSETS,
    cncSsrApiBaseUrl: PROD_VIEWER_BASE_URL,
    viewerAliasApiBaseUrl: PROD_VIEWER_ALIAS_BASE_URL,
    communityBaseUrl: COMMUNITY_BASE_URL,
    errorQueueUrl: PROD_ERROR_QUEUE_URL,
    statsDUrl: STATSD_URL,
    auth0Domain: AUTH0_DOMAIN,
    auth0Audience: AUTH0_AUDIENCE,
    auth0ClientId: PROD_AUTH0_CLIENT_ID,
    ometriaApiUrl: OMETRIA_API_PRODUCTION_URL,
    klaviyoApiUrl: KLAVIYO_API_PRODUCTION_URL,
    sfmcApiUrl: SFMC_API_PRODUCTION_URL,
    cloudinaryProviderUrl: CLOUDINARY_PROVIDER_PRODUCTION_URL,
    salesEmail: SALES_EMAIL,
    supportEmail: SUPPORT_EMAIL,
    editorSegmentIOKey: PROD_EDITOR_SEGMENT_IO_KEY,
    matomoConfig: MATOMO_PROD_CONFIG,
    zsitesConfig: ZSITES_PROD_URL,
    zsitesSecret: ZSITES_SECRET,
    inventoryUrl: INVENTORY_PROD_BASE_URL + INVENTORY_PRODUCT_URL,
    answerFileUrl: ANSWERFILE_PROD_BASE_URL + ANSWERFILE_DYNAMIC_PRICING_URL,
    experienceUrl2PngBaseUrl: MS_EXPERIENCES_PROD_BASE_URL + MS_PROXY_EXPERIENCES + MS_EXPERIENCES_URL2PNG_URL,
    experienceSharedEntityBaseUrl: MS_EXPERIENCES_PROD_BASE_URL + MS_PROXY_EXPERIENCES + MS_EXPERIENCES_SHARED_ENTITY_URL,
    msExperiencesUrl: MS_EXPERIENCES_PROD_BASE_URL + MS_PROXY_EXPERIENCES,
    microserviceCompanyUrl: MS_EXPERIENCES_PROD_BASE_URL + MS_PROXY_COMPANY,
    proxyUrl: MS_PROXY_PROD_BASE_URL,
    forgotPasswordBaseUrl: MS_PROXY_PROD_BASE_URL,
    resetPasswordBaseUrl: MS_PROXY_PROD_BASE_URL,
    changePasswordBaseUrl: MS_PROXY_PROD_BASE_URL,
    loginWithTokenBaseUrl: MS_PROXY_PROD_BASE_URL,
    loginWithPasswordBaseUrl: MS_PROXY_PROD_BASE_URL,
    loginWithSsoBaseUrl: MS_PROXY_PROD_BASE_URL,
    loginActiveDirectoryBaseUrl: PROD_LIVE_API_BASE_URL,
    googleWebFontsApiBaseUrl: GOOGLE_WEBFONTS_API_BASE_URL,
    googleWebFontsApiKey:GOOGLE_WEBFONTS_API_KEY,
    casUrl:PROD_CAS_URL,
    contentControlUrl: PROD_CONTENT_CONTROL_URL,
    enableLogging: 1,
    logId: null,
    trackErrors: true,
    sentryEnabled: true,
    sentryDSN: SENTRY_DSN,
    experienceId: null,
    groupId: null,
    scene: null,
    statsDBucket: "creator.prod",
    version: null,
    maxRetries: 3
};

/**
 * Development config (only for creator-dev.zmags.com)
 */
const DEV_CONFIG = {
    env: "DEV",
    cncViewFullBaseUrl: DEV_CNC_VIEW_FULL_BASE_URL,
    cncViewLiteBaseUrl: DEV_CNC_VIEW_LITE_BASE_URL,
    psdImportBaseUrl: DEV_PSD_IMPORT_BASE_URL,
    behaviorUiBaseUrl: DEV_BEHAVIOR_UI_BASE_URL,
    creatorSettingApiBaseUrl: DEV_CREATOR_SETTINGS_API_BASE_URL,
    c3ApibaseUrl: STAGE_C3_API_BASE_URI,
    adminApiBaseUrl: DEV_LIVE_API_BASE_URL,
    editorBaseUrl: DEV_EDITOR_BASE_URL,
    viewerBaseUrl: DEV_VIEWER_BASE_URL,
    viewerApiBaseUrl: DEV_VIEWER_BASE_URL,
    cncStaticAssetsBaseUrl: DEV_CNC_SSR_API_BASE_URL + "/static/", // "http://localhost:8081/static/",
    cncStaticAssetsFiles: CNC_STATIC_ASSETS,
    cncSsrApiBaseUrl: DEV_CNC_SSR_API_BASE_URL,
    viewerAliasApiBaseUrl: DEV_VIEWER_ALIAS_BASE_URL,
    communityBaseUrl: COMMUNITY_BASE_URL,
    errorQueueUrl: DEV_ERROR_QUEUE_URL,
    statsDUrl: STATSD_URL,
    auth0Domain: AUTH0_DOMAIN,
    auth0Audience: AUTH0_AUDIENCE,
    auth0ClientId: DEV_AUTH0_CLIENT_ID,
    ometriaApiUrl: OMETRIA_API_STAGE_URL,
    klaviyoApiUrl: KLAVIYO_API_STAGE_URL,
    sfmcApiUrl: SFMC_API_STAGE_URL,
    cloudinaryProviderUrl: CLOUDINARY_PROVIDER_BASE_URL,
    salesEmail: SALES_EMAIL,
    supportEmail: SUPPORT_EMAIL,
    editorSegmentIOKey: LOCAL_EDITOR_SEGMENT_IO_KEY,
    matomoConfig: MATOMO_DEV_CONFIG,
    zsitesConfig: ZSITES_DEV_URL,
    zsitesSecret: ZSITES_SECRET,
    inventoryUrl: INVENTORY_STAGE_BASE_URL + INVENTORY_PRODUCT_URL,
    answerFileUrl: ANSWERFILE_STAGE_BASE_URL + ANSWERFILE_DYNAMIC_PRICING_URL,
    experienceUrl2PngBaseUrl: MS_EXPERIENCES_STAGE_BASE_URL + MS_PROXY_EXPERIENCES + MS_EXPERIENCES_URL2PNG_URL,
    experienceSharedEntityBaseUrl: MS_EXPERIENCES_STAGE_BASE_URL + MS_PROXY_EXPERIENCES + MS_EXPERIENCES_SHARED_ENTITY_URL,
    msExperiencesUrl: MS_EXPERIENCES_STAGE_BASE_URL + MS_PROXY_EXPERIENCES,
    microserviceCompanyUrl: MS_EXPERIENCES_STAGE_BASE_URL + MS_PROXY_COMPANY,
    proxyUrl: MS_PROXY_STAGE_BASE_URL,
    forgotPasswordBaseUrl: MS_PROXY_STAGE_BASE_URL,
    resetPasswordBaseUrl: MS_PROXY_STAGE_BASE_URL,
    changePasswordBaseUrl: MS_PROXY_STAGE_BASE_URL,
    loginWithTokenBaseUrl: MS_PROXY_STAGE_BASE_URL,
    loginWithPasswordBaseUrl: MS_PROXY_STAGE_BASE_URL,
    loginWithSsoBaseUrl: MS_PROXY_STAGE_BASE_URL,
    loginActiveDirectoryBaseUrl: DEV_LIVE_API_BASE_URL,
    googleWebFontsApiBaseUrl: GOOGLE_WEBFONTS_API_BASE_URL,
    googleWebFontsApiKey:GOOGLE_WEBFONTS_API_KEY,
    casUrl:DEV_CAS_URL,
    contentControlUrl: DEV_CONTENT_CONTROL_URL,
    enableLogging: 2,
    logId: null,
    trackErrors: true,
    sentryEnabled: true,
    sentryDSN: SENTRY_DSN,
    experienceId: null,
    groupId: null,
    scene: null,
    statsDBucket: "creator.dev",
    version: null,
    maxRetries: 3

};

/**
 * Branch config, running against their own backends and frontends (Cover master branch and all other dev branches).
 */
const BRANCH_CONFIG = {
    env: "BRANCH",
    // The baseUrls must be configured per branch. See configure-branch and build:branch task and injectBranchConfig function.
    // see Gruntfile.js
    // adminApiBaseUrl:
    // editorBaseUrl:
    // viewerBaseUrl:
    // viewerApiBaseUrl:
    // viewerAliasApiBaseUrl:
    cncViewFullBaseUrl: DEV_CNC_VIEW_FULL_BASE_URL,
    cncViewLiteBaseUrl: DEV_CNC_VIEW_LITE_BASE_URL,
    psdImportBaseUrl: DEV_PSD_IMPORT_BASE_URL,
    behaviorUiBaseUrl: DEV_BEHAVIOR_UI_BASE_URL,
    creatorSettingApiBaseUrl: DEV_CREATOR_SETTINGS_API_BASE_URL,
    c3ApibaseUrl: DEV_C3_API_BASE_URI,
    cncStaticAssetsBaseUrl: "//localhost:8081/static/",
    cncStaticAssetsFiles: CNC_STATIC_ASSETS,
    cncSsrApiBaseUrl: DEV_CNC_SSR_API_BASE_URL,
    communityBaseUrl: COMMUNITY_BASE_URL,
    errorQueueUrl: DEV_ERROR_QUEUE_URL,
    statsDUrl: STATSD_URL,
    auth0Domain: AUTH0_DOMAIN,
    auth0Audience: AUTH0_AUDIENCE,
    auth0ClientId: DEV_AUTH0_CLIENT_ID,
    ometriaApiUrl: OMETRIA_API_STAGE_URL,
    klaviyoApiUrl: KLAVIYO_API_STAGE_URL,
    sfmcApiUrl: SFMC_API_STAGE_URL,
    cloudinaryProviderUrl: CLOUDINARY_PROVIDER_BASE_URL,
    salesEmail: SALES_EMAIL,
    supportEmail: SUPPORT_EMAIL,
    editorSegmentIOKey: BRANCH_EDITOR_SEGMENT_IO_KEY,
    matomoConfig: MATOMO_BRANCH_CONFIG,
    zsitesConfig: ZSITES_BRANCH_URL,
    zsitesSecret: ZSITES_SECRET,
    inventoryUrl: INVENTORY_LOCAL_BASE_URL + INVENTORY_PRODUCT_URL,
    // This is direct to ms-experiences bypassing the proxy since branch proxy auth doesn't work
    experienceUrl2PngBaseUrl: MS_EXPERIENCES_BRANCH_BASE_URL + MS_EXPERIENCES_URL2PNG_URL,
    experienceSharedEntityBaseUrl: MS_EXPERIENCES_BRANCH_BASE_URL + MS_PROXY_EXPERIENCES + MS_EXPERIENCES_SHARED_ENTITY_URL,
    msExperiencesUrl: MS_EXPERIENCES_BRANCH_BASE_URL + MS_PROXY_EXPERIENCES,
    microserviceCompanyUrl: MS_EXPERIENCES_BRANCH_BASE_URL + MS_PROXY_COMPANY,
    // experienceUrl2PngBaseUrl: MS_EXPERIENCES_LOCAL_BASE_URL + MS_EXPERIENCES_URL2PNG_URL,
    proxyUrl: MS_PROXY_BRANCH_BASE_URL,
    // forgotPasswordBaseUrl: MS_PROXY_BRANCH_BASE_URL,
    // resetPasswordBaseUrl: MS_PROXY_BRANCH_BASE_URL,
    // changePasswordBaseUrl: MS_PROXY_BRANCH_BASE_URL,
    // loginWithTokenBaseUrl: MS_PROXY_BRANCH_BASE_URL,
    // loginWithPasswordBaseUrl: MS_PROXY_BRANCH_BASE_URL,
    // loginWithSsoBaseUrl: MS_PROXY_BRANCH_BASE_URL,
    // loginActiveDirectoryBaseUrl: MS_PROXY_BRANCH_BASE_URL,
    googleWebFontsApiBaseUrl: GOOGLE_WEBFONTS_API_BASE_URL,
    googleWebFontsApiKey: GOOGLE_WEBFONTS_API_KEY,
    branchImagesBaseUrl: BRANCH_IMAGES_BASE_URL,
    contentControlUrl: LOCAL_CONTENT_CONTROL_URL,
    enableLogging: 1,
    logId: null,
    trackErrors: true,
    sentryEnabled: true,
    sentryDSN: SENTRY_DSN,
    experienceId: null,
    groupId: null,
    scene: null,
    version: null,
    maxRetries: 3
};

/**
 * Local config for running local backend
 */
const LOCAL_CONFIG = {
    env: "LOCAL",
    cncViewFullBaseUrl: "http://localhost:8081/view/full/",
    cncViewLiteBaseUrl: "http://localhost:8081/view/lite/",
    psdImportBaseUrl: "http://localhost:3000",
    behaviorUiBaseUrl: "http://localhost:3000",
    creatorSettingApiBaseUrl: DEV_CREATOR_SETTINGS_API_BASE_URL,
    c3ApibaseUrl: DEV_C3_API_BASE_URI,
    adminApiBaseUrl: LOCAL_LIVE_API_BASE_URL,
    editorBaseUrl: LOCAL_EDITOR_BASE_URL,
    viewerBaseUrl: LOCAL_EDITOR_BASE_URL,
    viewerApiBaseUrl: LOCAL_EDITOR_BASE_URL,
    viewerAliasApiBaseUrl: LOCAL_EDITOR_BASE_URL,
    cncStaticAssetsBaseUrl: "http://localhost:8081/static/",
    cncStaticAssetsFiles: CNC_STATIC_ASSETS,
    // This isn't really the API base URL so much so as the env base URL.
    cncSsrApiBaseUrl: "http://localhost:8081",
    communityBaseUrl: COMMUNITY_BASE_URL,
    errorQueueUrl: DEV_ERROR_QUEUE_URL,
    statsDUrl: STATSD_URL,
    auth0Domain: AUTH0_DOMAIN,
    auth0Audience: AUTH0_AUDIENCE,
    auth0ClientId: DEV_AUTH0_CLIENT_ID,
    ometriaApiUrl: OMETRIA_API_STAGE_URL,
    klaviyoApiUrl: KLAVIYO_API_STAGE_URL,
    sfmcApiUrl: SFMC_API_STAGE_URL,
    cloudinaryProviderUrl: CLOUDINARY_PROVIDER_BASE_URL,
    salesEmail: SALES_EMAIL,
    supportEmail: SUPPORT_EMAIL,
    editorSegmentIOKey: LOCAL_EDITOR_SEGMENT_IO_KEY,
    matomoConfig: MATOMO_LOCAL_CONFIG,
    zsitesConfig: ZSITES_LOCAL_URL,
    zsitesSecret: ZSITES_SECRET,
    inventoryUrl: INVENTORY_LOCAL_BASE_URL + INVENTORY_PRODUCT_URL,
    experienceUrl2PngBaseUrl: MS_EXPERIENCES_LOCAL_BASE_URL + MS_EXPERIENCES_URL2PNG_URL,
    experienceSharedEntityBaseUrl: MS_EXPERIENCES_LOCAL_BASE_URL + MS_PROXY_EXPERIENCES + MS_EXPERIENCES_SHARED_ENTITY_URL,
    microserviceCompanyUrl: MS_EXPERIENCES_LOCAL_BASE_URL + MS_PROXY_COMPANY,
    msExperiencesUrl: MS_EXPERIENCES_LOCAL_BASE_URL + MS_PROXY_EXPERIENCES,
    proxyUrl: MS_PROXY_LOCAL_BASE_URL,
    forgotPasswordBaseUrl: MS_PROXY_LOCAL_BASE_URL,
    resetPasswordBaseUrl: MS_PROXY_LOCAL_BASE_URL,
    changePasswordBaseUrl: MS_PROXY_LOCAL_BASE_URL,
    loginWithTokenBaseUrl: MS_PROXY_LOCAL_BASE_URL,
    loginWithPasswordBaseUrl: MS_PROXY_LOCAL_BASE_URL,
    loginWithSsoBaseUrl: MS_PROXY_LOCAL_BASE_URL,
    loginActiveDirectoryBaseUrl: LOCAL_LIVE_API_BASE_URL,
    googleWebFontsApiBaseUrl: GOOGLE_WEBFONTS_API_BASE_URL,
    googleWebFontsApiKey:GOOGLE_WEBFONTS_API_KEY,
    casUrl:DEV_CAS_URL,
    contentControlUrl: LOCAL_CONTENT_CONTROL_URL,
    enableLogging: 1,
    logId: null,
    trackErrors: false,
    sentryEnabled: false,
    sentryDSN: "", // confirm DSN before enabling above.
    experienceId: null,
    groupId: null,
    scene: null,
    version: null,
    maxRetries: 3
};

/**
 * Config for running docker images for experience-server, experience-client, zelp, and CNC within
 * docker and using staging (creator-dev.zmags.com) for other resources.
 */
const DOCKER_STAGE_CONFIG = {
    env: "DOCKER_STAGE",
    cncViewFullBaseUrl: DOCKER_STAGE_CNC_VIEW_FULL_BASE_URL,
    cncViewLiteBaseUrl: DOCKER_STAGE_CNC_VIEW_LITE_BASE_URL,
    psdImportBaseUrl: DEV_PSD_IMPORT_BASE_URL,
    behaviorUiBaseUrl: DEV_BEHAVIOR_UI_BASE_URL,
    creatorSettingApiBaseUrl: DEV_CREATOR_SETTINGS_API_BASE_URL,
    c3ApibaseUrl: DEV_C3_API_BASE_URI,
    adminApiBaseUrl: DOCKER_STAGE_LIVE_API_BASE_URL,
    viewerBaseUrl: DEV_VIEWER_BASE_URL, // Leave this at S3 for now
    viewerApiBaseUrl: DEV_VIEWER_BASE_URL,

//  this points to S3 via akamai.  Is this right?
    cncStaticAssetsBaseUrl: DEV_CNC_SSR_API_BASE_URL + "/static/",
    cncStaticAssetsFiles: CNC_STATIC_ASSETS,
    cncSsrApiBaseUrl: DEV_CNC_SSR_API_BASE_URL,
    viewerAliasApiBaseUrl: DEV_VIEWER_ALIAS_BASE_URL,
    communityBaseUrl: COMMUNITY_BASE_URL,
    errorQueueUrl: DEV_ERROR_QUEUE_URL,
    statsDUrl: STATSD_URL,
    auth0Domain: AUTH0_DOMAIN,
    auth0Audience: AUTH0_AUDIENCE,
    auth0ClientId: DEV_AUTH0_CLIENT_ID,
    ometriaApiUrl: OMETRIA_API_STAGE_URL,
    klaviyoApiUrl: KLAVIYO_API_STAGE_URL,
    sfmcApiUrl: SFMC_API_STAGE_URL,
    cloudinaryProviderUrl: CLOUDINARY_PROVIDER_BASE_URL,
    salesEmail: SALES_EMAIL,
    supportEmail: SUPPORT_EMAIL,
    editorSegmentIOKey: LOCAL_EDITOR_SEGMENT_IO_KEY,
    matomoConfig: MATOMO_DEV_CONFIG,
    zsitesConfig: ZSITES_DEV_URL,
    zsitesSecret: ZSITES_SECRET,
    inventoryUrl: INVENTORY_STAGE_BASE_URL + INVENTORY_PRODUCT_URL,
    answerFileUrl: ANSWERFILE_STAGE_BASE_URL + ANSWERFILE_DYNAMIC_PRICING_URL,
    experienceUrl2PngBaseUrl: MS_EXPERIENCES_STAGE_BASE_URL + MS_PROXY_EXPERIENCES + MS_EXPERIENCES_URL2PNG_URL,
    experienceSharedEntityBaseUrl: MS_EXPERIENCES_STAGE_BASE_URL + MS_PROXY_EXPERIENCES + MS_EXPERIENCES_SHARED_ENTITY_URL,
    microserviceCompanyUrl: MS_EXPERIENCES_STAGE_BASE_URL + MS_PROXY_COMPANY,
    msExperiencesUrl: MS_EXPERIENCES_STAGE_BASE_URL + MS_PROXY_EXPERIENCES,
    proxyUrl: MS_PROXY_DOCKER_STAGE_BASE_URL, //docker talks to stage was the original value!  Not sure this was correct @eric?
    forgotPasswordBaseUrl: MS_PROXY_DOCKER_STAGE_BASE_URL,
    resetPasswordBaseUrl: MS_PROXY_DOCKER_STAGE_BASE_URL,
    changePasswordBaseUrl: MS_PROXY_DOCKER_STAGE_BASE_URL,
    loginWithTokenBaseUrl: MS_PROXY_DOCKER_STAGE_BASE_URL,
    loginWithPasswordBaseUrl: MS_PROXY_DOCKER_STAGE_BASE_URL,
    loginWithSsoBaseUrl: MS_PROXY_DOCKER_STAGE_BASE_URL,
    loginActiveDirectoryBaseUrl: DOCKER_STAGE_LIVE_API_BASE_URL,
    googleWebFontsApiBaseUrl: GOOGLE_WEBFONTS_API_BASE_URL,
    googleWebFontsApiKey:GOOGLE_WEBFONTS_API_KEY,
    contentControlUrl: LOCAL_CONTENT_CONTROL_URL,
    enableLogging: 2,
    logId: null,
    trackErrors: true,
    sentryEnabled: true,
    sentryDSN: SENTRY_DSN,
    experienceId: null,
    groupId: null,
    scene: null,
    statsDBucket: "creator.dev",
    version: null,
    maxRetries: 3

};

/**
 *  Config for running docker-based experience-client against local services.
 * The work for this running mode is not completed.
 */
const DOCKER_CONFIG = {
    env: "DOCKER",
    cncViewFullBaseUrl: "http://localhost:8081/view/full/",
    cncViewLiteBaseUrl: "http://localhost:8081/view/lite/",
    psdImportBaseUrl: "http://localhost:3000",
    behaviorUiBaseUrl: "http://localhost:3000",
    adminApiBaseUrl: DOCKER_LIVE_API_BASE_URL,
    editorBaseUrl: DOCKER_EDITOR_BASE_URL,
    viewerBaseUrl: DOCKER_EDITOR_BASE_URL,
    viewerApiBaseUrl: DOCKER_EDITOR_BASE_URL,
    viewerAliasApiBaseUrl: DOCKER_EDITOR_BASE_URL,
    cncStaticAssetsBaseUrl: "http://localhost:8081/static/",
    cncStaticAssetsFiles: CNC_STATIC_ASSETS,
    // This isn't really the API base URL so much so as the env base URL.
    cncSsrApiBaseUrl: "http://locahost:8081",
    communityBaseUrl: COMMUNITY_BASE_URL,
    errorQueueUrl: DEV_ERROR_QUEUE_URL,
    statsDUrl: STATSD_URL,
    auth0Domain: AUTH0_DOMAIN,
    auth0Audience: AUTH0_AUDIENCE,
    auth0ClientId: DEV_AUTH0_CLIENT_ID,
    ometriaApiUrl: OMETRIA_API_STAGE_URL,
    klaviyoApiUrl: KLAVIYO_API_STAGE_URL,
    sfmcApiUrl: SFMC_API_STAGE_URL,
    cloudinaryProviderUrl: CLOUDINARY_PROVIDER_BASE_URL,
    salesEmail: SALES_EMAIL,
    supportEmail: SUPPORT_EMAIL,
    editorSegmentIOKey: LOCAL_EDITOR_SEGMENT_IO_KEY,
    matomoConfig: MATOMO_DOCKER_CONFIG,
    zsitesConfig: ZSITES_DOCKER_URL,
    zsitesSecret: ZSITES_SECRET,
    inventoryUrl: INVENTORY_DOCKER_BASE_URL + INVENTORY_PRODUCT_URL,
    experienceUrl2PngBaseUrl: MS_EXPERIENCES_DOCKER_BASE_URL + MS_EXPERIENCES_URL2PNG_URL,
    experienceSharedEntityBaseUrl: MS_EXPERIENCES_DOCKER_BASE_URL + MS_PROXY_EXPERIENCES + MS_EXPERIENCES_SHARED_ENTITY_URL,
    microserviceCompanyUrl: MS_EXPERIENCES_DOCKER_BASE_URL + MS_PROXY_COMPANY,
    msExperiencesUrl: MS_EXPERIENCES_DOCKER_BASE_URL + MS_PROXY_EXPERIENCES,
    proxyUrl: MS_PROXY_DOCKER_BASE_URL,
    forgotPasswordBaseUrl: MS_PROXY_DOCKER_BASE_URL,
    resetPasswordBaseUrl: MS_PROXY_DOCKER_BASE_URL,
    changePasswordBaseUrl: MS_PROXY_DOCKER_BASE_URL,
    loginWithTokenBaseUrl: MS_PROXY_DOCKER_BASE_URL,
    loginWithPasswordBaseUrl: MS_PROXY_DOCKER_BASE_URL,
    loginWithSsoBaseUrl: MS_PROXY_DOCKER_BASE_URL,
    loginActiveDirectoryBaseUrl: DOCKER_LIVE_API_BASE_URL,
    googleWebFontsApiBaseUrl: GOOGLE_WEBFONTS_API_BASE_URL,
    googleWebFontsApiKey: GOOGLE_WEBFONTS_API_KEY,
    branchImagesBaseUrl: BRANCH_IMAGES_BASE_URL,
    enableLogging: 1,
    logId: null,
    trackErrors: false,
    sentryEnabled: false,
    sentryDSN: "", // confirm DSN before enabling above.
    experienceId: null,
    groupId: null,
    scene: null,
    version: null,
    maxRetries: 3
};

/**
 * Configuration for the docker cluster version running up in ECS
 */
const DOCKER_CLUSTER_CONFIG = {
    env: "DOCKER_CLUSTER",
	cncViewFullBaseUrl: DOCKER_CLUSTER_CNC_BASE_URL + "/view/full/",
	cncViewLiteBaseUrl: DOCKER_CLUSTER_CNC_BASE_URL + "/view/lite/",
    behaviorUiBaseUrl: DOCKER_CLUSTER_BEHAVIOR_UI_BASE_URL,
    psdImportBaseUrl: DOCKER_CLUSTER_PSD_IMPORT_BASE_URL,
    adminApiBaseUrl: DOCKER_CLUSTER_LIVE_API_BASE_URL,
    editorBaseUrl: DOCKER_CLUSTER_CREATOR_BASE_URL,
    viewerBaseUrl: DOCKER_CLUSTER_CREATOR_BASE_URL,
    viewerApiBaseUrl: DOCKER_CLUSTER_CREATOR_BASE_URL,
    cncStaticAssetsBaseUrl: DOCKER_CLUSTER_CREATOR_BASE_URL + "/static/", // "http://localhost:8081/static/",
    cncStaticAssetsFiles: CNC_STATIC_ASSETS,
    cncSsrApiBaseUrl: DOCKER_CLUSTER_CREATOR_BASE_URL,
    viewerAliasApiBaseUrl: DOCKER_CLUSTER_CREATOR_BASE_URL,
    communityBaseUrl: COMMUNITY_BASE_URL,
    errorQueueUrl: DOCKER_CLUSTER_ERROR_QUEUE_URL,
    statsDUrl: STATSD_URL,
    auth0Domain: AUTH0_DOMAIN,
    auth0Audience: AUTH0_AUDIENCE,
    auth0ClientId: DEV_AUTH0_CLIENT_ID,
    ometriaApiUrl: OMETRIA_API_STAGE_URL,
    klaviyoApiUrl: KLAVIYO_API_STAGE_URL,
    sfmcApiUrl: SFMC_API_STAGE_URL,
    cloudinaryProviderUrl: CLOUDINARY_PROVIDER_DOCKER_CLUSTER_URL,
    salesEmail: SALES_EMAIL,
    supportEmail: SUPPORT_EMAIL,
    editorSegmentIOKey: BRANCH_EDITOR_SEGMENT_IO_KEY,
    matomoConfig: MATOMO_DOCKER_CLUSTER_CONFIG,
    //zsitesConfig: ZSITES_DOCKER_CLUSTER_URL,
    //zsitesSecret: ZSITES_SECRET,
    inventoryUrl: MS_PROXY_DOCKER_CLUSTER_BASE_URL + INVENTORY_PRODUCT_URL,
    answerFileUrl: ANSWERFILE_DOCKER_CLUSTER_BASE_URL + ANSWERFILE_DYNAMIC_PRICING_URL,
    experienceUrl2PngBaseUrl: MS_PROXY_DOCKER_CLUSTER_BASE_URL + MS_PROXY_EXPERIENCES + MS_EXPERIENCES_URL2PNG_URL,
    experienceSharedEntityBaseUrl: MS_PROXY_DOCKER_CLUSTER_BASE_URL + MS_PROXY_EXPERIENCES + MS_EXPERIENCES_SHARED_ENTITY_URL,
    msExperiencesUrl: MS_PROXY_DOCKER_CLUSTER_BASE_URL + MS_PROXY_EXPERIENCES,
    microserviceCompanyUrl: MS_PROXY_DOCKER_CLUSTER_BASE_URL + MS_PROXY_COMPANY,
    proxyUrl: MS_PROXY_DOCKER_CLUSTER_BASE_URL,
    forgotPasswordBaseUrl: MS_PROXY_DOCKER_CLUSTER_BASE_URL,
    resetPasswordBaseUrl: MS_PROXY_DOCKER_CLUSTER_BASE_URL,
    changePasswordBaseUrl: MS_PROXY_DOCKER_CLUSTER_BASE_URL,
    loginWithTokenBaseUrl: MS_PROXY_DOCKER_CLUSTER_BASE_URL,
    loginWithPasswordBaseUrl: MS_PROXY_DOCKER_CLUSTER_BASE_URL,
    loginWithSsoBaseUrl: MS_PROXY_DOCKER_CLUSTER_BASE_URL,
    loginActiveDirectoryBaseUrl: DOCKER_CLUSTER_LIVE_API_BASE_URL,
    googleWebFontsApiBaseUrl: GOOGLE_WEBFONTS_API_BASE_URL,
    googleWebFontsApiKey: GOOGLE_WEBFONTS_API_KEY,
    contentControlUrl: LOCAL_CONTENT_CONTROL_URL,
    enableLogging: 2,
    logId: null,
    trackErrors: true,
    experienceId: null,
    groupId: null,
    scene: null,
    statsDBucket: "creator.dev",
    version: null,
    maxRetries: 3
};

/**
 * CNC Development config. Made for developing locally against the DEV (c-dev.zmags.com) API.
 * These are the values used in CNC.
 *
 * To access unpushed experiences in DEV you may replace viewerApiBaseUrl's value with DEV_LIVE_API_BASE_URL but you
 * must provide a bearer token as its an auth protected end point. To provide a bearer token you must add the option
 * to the request in the following file experience-client/src/viewer-xp/api/index.ts.
 *
 * You may also replace it with http://localhost:8081. This is useful if you need to work offline or want to provide
 * your own custom data that isn't easily accessible.
 *
 * If you switch viewerApiBaseUrl to localhost the apiRouter will be used.
 * If you switch viewerBaseUrl to localhost the assetRouter will be used.
 */
const CNC_CONFIG = {
    cncViewFullBaseUrl: DEV_CNC_VIEW_FULL_BASE_URL,
    cncViewLiteBaseUrl: DEV_CNC_VIEW_LITE_BASE_URL,
    // The root for API requests. This will have "/api" appended to the URL.
    viewerApiBaseUrl: DEV_VIEWER_BASE_URL,
    // This gets prepended to relative URLs for image widgets.
    viewerBaseUrl: DEV_VIEWER_BASE_URL,
    // These should be added if you want to enable the corresponding tracker.
    matomoConfig: MATOMO_DEV_CONFIG,
    enableLogging: 3, // Highest level of logging -- VERBOSE
    cncStaticAssetsBaseUrl: "/static/" // Used to set public path in webpack output. Used to host client assets.
};

module.exports = {
    Names: EnvironmentNames,

    getConfiguration: function(type, buildVersion) {
        var configuration;

        switch (type) {
            case EnvironmentNames.LOCAL:
                configuration = LOCAL_CONFIG;
                break;

            case EnvironmentNames.DOCKER_STAGE:
                configuration = DOCKER_STAGE_CONFIG;
                break;

            case EnvironmentNames.DOCKER_CLUSTER:
                configuration = DOCKER_CLUSTER_CONFIG;
                break;

            case EnvironmentNames.DEV:
                configuration = DEV_CONFIG;
                break;

            case EnvironmentNames.PROD:
                configuration = PROD_CONFIG;
                break;

            case EnvironmentNames.BRANCH:
                configuration = BRANCH_CONFIG;
                break;

            case EnvironmentNames.CNC:
                configuration = CNC_CONFIG;
                break;

            default:
                throw new Error("Cannot find configuration for type: " + type);
        }

        configuration.version = buildVersion;

        return configuration;
    }
};



//////////////////
// WEBPACK FOOTER
// ./webpack-config/environments.js
// module id = 1379
// module chunks = 0